<template>

    <section v-if="visible">
        <slot></slot>
    </section>

</template>

<style lang="scss">
    .crud main section{
        @include clearfix();
    }
</style>

<script>
    export default {
        data() {
            return {
                visible: true
            }
        },
        watch: {},
        computed: {
            name(){
                return this.$parent.name;
            }
        },
        methods: {},
        mounted() {
            var that = this;
            
            window.eventBus.$on('crud-show-new-'+this.name, function () {
                that.visible = true;
            });

            window.eventBus.$on('crud-hide-new-'+this.name, function () {
                that.visible = false;
            });

        }
    }
</script>   
